import { Stack } from "@certn/cascadia";
import { Card, Icon } from "@certn/cascadia-react";
import { Skeleton } from "@certn/cascadia-react/patterns/skeleton/Skeleton";
import { css } from "@emotion/css";

export function PackageCardSkeleton() {
  return (
    <Card className={styles.card}>
      <Stack>
        <Stack gap="space-2">
          <div className={styles.titleSection}>
            <div className={styles.title}>
              <Icon name="package_2" color="icon-accent-tofino" />
              <Skeleton width={200} height={24} />
            </div>
          </div>
          <Skeleton width={300} height={20} />
          <Skeleton width={250} height={20} />
        </Stack>
        <Stack gap="space-2">
          <div className={styles.paddedDiv}>
            <Skeleton width={150} height={24} />
          </div>
          <Skeleton width={100} height={24} />
        </Stack>
        <Stack orientation="horizontal" justify="space-between">
          <Skeleton width={120} height={36} />
          <Skeleton width={120} height={36} />
        </Stack>
      </Stack>
    </Card>
  );
}

const styles = {
  card: css({
    display: "flex",
    height: 160,
    width: 365,
    minWidth: 260,
    maxWidth: 488,
    borderRadius: "var(--border-radius-3)",
    "&:hover": {
      boxShadow: "var(--shadow-card)",
    },
    "&[data-focus-visible]": {
      boxShadow: "var(--focus-action)",
    },
    padding: "var(--space-3) var(--space-4) var(--space-4)",
  }),
  titleSection: css({
    display: "flex",
    justifyContent: "space-between",
  }),
  title: css({
    display: "flex",
    alignItems: "center",
    gap: "var(--space-2)",
  }),
  paddedDiv: css({
    paddingTop: "var(--space-2)",
  }),
};
